import { useEffect, useState } from 'react';
import { enrollmentPhase } from '../lib/winter';

// Returns 'pre' | 'priority' | 'open' for Winter enrollment.
export default function useSiteMode() {
  const [mode, setMode] = useState(() => enrollmentPhase());
  useEffect(() => {
    const id = setInterval(() => setMode(enrollmentPhase()), 60_000);
    return () => clearInterval(id);
  }, []);
  return mode;
}
